export default "__VITE_ASSET__DWf6asix__"